var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { Icon, TouchFeedback, ButtonGroup } from 'rcm-mobile';
import './style/index.scss';
/**
 * @author tongxiaokang
 * @version 0.0.1
 *
 * 实现了 [TouchFeedback](#/Components/TouchFeedback) 组件所有的API。
 */
export default class Button extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = (e) => {
            const { onClick } = this.props;
            if (this.state.disabled) { // 禁用跳转
                e.preventDefault();
            }
            else {
                onClick && onClick(e);
            }
        };
        this.state = {
            disabled: props.loading || props.disabled
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.loading !== prevState.loading) {
            return { loading: nextProps.loading };
        }
        return null;
    }
    render() {
        const _a = this.props, { prefixCls, size, loadingIcon, theme, disabled: _disabled, onClick, radius, activeStyle, activeClassName, loading, inline, href, className, children, type } = _a, resetProps = __rest(_a, ["prefixCls", "size", "loadingIcon", "theme", "disabled", "onClick", "radius", "activeStyle", "activeClassName", "loading", "inline", "href", "className", "children", "type"]);
        const { disabled } = this.state;
        return (<TouchFeedback disabled={disabled} activeStyle={activeStyle} activeClassName={activeClassName}>
        <a href={href || 'javascript:;'} onClick={this.handleClick} className={cls(className, prefixCls, size, {
            'x-radius': radius,
            'x-dis-inline': inline,
            [`x-${theme}`]: theme,
            'x-disabled': disabled
        })} {...resetProps}>
          {!loading ? null
            : (loadingIcon || <Icon style={{ marginRight: '.5rem' }} className={'x-icon-loading'} spin/>)}
          {children}
        </a>
      </TouchFeedback>);
    }
    /**
     * ButtonGroup组件
     * @public
     * */
    static Group(props) {
        return <ButtonGroup {...props}/>;
    }
}
Button.defaultProps = {
    prefixCls: 'x-button',
    type: 'button',
    theme: 'text',
    radius: false,
    inline: false,
    loading: false,
    disabled: false
};
